import { LegalShell } from "../components/LegalShell";
import { useSeo } from "../lib/useSeo";

const AboutUs = () => {
    useSeo({
        title: "About Us | Shillong Morning Teer Result Today",
        description: "Learn about Shillong Morning Teer Result Today — our mission to deliver the fastest, most reliable Shillong Morning Teer FR & SR results, previous charts and common numbers.",
        keywords: "about shillong morning teer, morning teer result website, morningteerkhela about",
        path: "/about-us",
        breadcrumbs: [
            { name: "Home", path: "/" },
            { name: "About Us", path: "/about-us" },
        ],
    });

    return (
        <LegalShell title="About Us" subtitle="Who we are and what we do." breadcrumb="About Us">
            <p>
                Welcome to <strong>Shillong Morning Teer Result Today</strong>, the fastest and most
                trusted destination for daily Shillong Morning Teer results. Our platform is dedicated
                to publishing authentic First Round (FR) and Second Round (SR) Teer numbers, previous
                results, common number predictions, dream number listings and direct hit guti — all
                organised in a clean, mobile-first interface.
            </p>

            <h2>Our Mission</h2>
            <p>
                Our mission is simple: to be the single most reliable source of Shillong Morning Teer
                information on the internet. Teer is more than a lottery in Meghalaya — it is a deeply
                traditional practice tied to the archery clubs of the region. We believe visitors
                deserve results that are timely, accurate, ad-light, and easy to access on any device,
                even on slow mobile connections.
            </p>

            <h2>What We Cover</h2>
            <ul>
                <li><strong>Shillong Morning Teer</strong> — FR at 10:30 AM and SR at 11:30 AM.</li>
                <li><strong>Shillong Teer (Day)</strong> — FR at 4:00 PM and SR at 5:00 PM.</li>
                <li><strong>Khanapara Teer, Juwai Teer, Bhutan Teer</strong> and other allied markets.</li>
                <li><strong>Shillong Night Teer</strong> and <strong>Night Teer</strong> late-hour results.</li>
                <li>Previous results archive, common number lists, dream numbers, and direct hit guti.</li>
            </ul>

            <h2>Why Choose Us</h2>
            <p>
                We built <strong>MorningTeerKhela.com</strong> for real players — no cluttered popups,
                no misleading claims, and no bloated pages. Every result on our site is published as
                soon as it is officially declared at the respective archery grounds. Our design is
                optimised for Core Web Vitals so you can check the numbers within seconds.
            </p>

            <h2>Editorial Standards</h2>
            <p>
                We do not manipulate, generate, or fabricate results. Numbers are recorded exactly as
                announced. Prediction pages (common number, dream number, hit guti) are provided for
                informational and analytical purposes only and should never be treated as guarantees.
            </p>

            <h2>Contact</h2>
            <p>
                Have feedback, spotted a typo, or want to partner with us? Please visit our{" "}
                <a href="/contact-us">Contact page</a> — we typically reply within one working day.
            </p>
        </LegalShell>
    );
};

export default AboutUs;
